import { render, staticRenderFns } from "./fictitious.vue?vue&type=template&id=7b630030&scoped=true&"
import script from "./fictitious.vue?vue&type=script&lang=js&"
export * from "./fictitious.vue?vue&type=script&lang=js&"
import style0 from "./fictitious.vue?vue&type=style&index=0&id=7b630030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b630030",
  null
  
)

export default component.exports